<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-menu':_state.visibleMenu},
    {'is-visible-menu-left':state.visibleMenuLeft}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="_state.visibleMenu"
      @closeMenu="_state.visibleMenu = false"
    />

    <!-- アップデート通知 -->
    <transition name="popup">
      <SPProfileAlertSetting
        v-if="_state.visibleProfileAlertSetting"
        :parentGroup1="group1"
        @closeProfileAlertSetting="_state.visibleProfileAlertSetting = false"
      />
    </transition>

    <!-- 書籍の設定ウィンドウ -->
    <transition name="popup">
      <SPProfileContractedBookSetting
        v-show="_state.visibleProfileContractedBookSetting"
        :startLoading="_state.visibleProfileContractedBookSetting"
        :currentAlertBooks="group1.alert_books"
        @emitSetAlertBooks="group1.setAlertBooks"
        @closeProfileContractedBookSetting="_state.visibleProfileContractedBookSetting = false"
      />
    </transition>

    <!-- 削除 -->
    <transition name="popup">
      <SPAlertListDeleteConfirm
        v-if="state.visibleAlertListDeleteConfirm"
        @closeAlertListDeleteConfirm="state.visibleAlertListDeleteConfirm = false"
      />
    </transition>

    <!-- 一括削除 -->
    <transition name="popup">
      <SPAlertListDeleteInBulkConfirm
        v-if="state.visibleAlertListDeleteInBulkConfirm"
        @closeAlertListDeleteInBulkConfirm="state.visibleAlertListDeleteInBulkConfirm = false"
      />
    </transition>

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-2"
          @click="_state.visibleMenu = true;state.visibleWindowDetail = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>


      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack />
          <div class="header-title">
            <h1>アップデート通知</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-heading">
            <div class="main-heading-row main-heading-result column">
              <template v-if="data.count !== null && data.count !== 0">
                <div class="main-heading-result-num col-8">{{data.count}}件</div>
                <div class="main-heading-delete col-4"><button
                  @click="state.visibleAlertListDeleteInBulkConfirm = true"
                >一括削除</button></div>
              </template>
            </div>
          </div>
          <SPScrollList
            :complete="data.complete"
            @scroll="handleScroll"
            >
            <div class="notification">
              <p class="notification-text">アップデート通知は最新100件まで表示されます。それ以前のアップデート通知は自動的に削除させていただきます。</p>
              <p class="notification-link" @click="_state.visibleProfileAlertSetting = true">アップデート通知の設定を変更する</p>
            </div>
            <!-- TODO: SP用に調整 -->
            <p v-if="data.complete && data.count <= 0" class="ml20 mt20 txt">アップデート通知はありません</p>

            <template v-for="(dateLists, index) in data.groupDateLists">
              <div :key="'_date_' + index" class="date">{{formatDate(index)}}</div>

              <ul :key="'alert_lists_' + index" class="list-result list-result-03">
                <li v-for="(list, dateIndex) in dateLists" :key="'date_'+ index + 'list' + dateIndex" class="list-result-item">
                  <div class="list-result-item-main">
                    <template v-if="list.deleted == 1">
                      <p class="list-result-sup">閲覧できなくなりました。</p>
                      <div class="list-result-title is-inactive"><p>{{list.title}}</p></div>
                    </template>
                    <template v-else-if="list.auth_message">
                      <div class="list-result-message">{{list.auth_message}}</div>
                      <div class="list-result-title"><span class="is-inactive">{{list.title}}</span></div>
                    </template>
                    <template v-else>
                      <div class="list-result-title"><a @click="action.routeList(list)">{{list.title}}</a></div>
                    </template>
                    <div class="list-result-note mb0" v-if="list.type == 'qa'">
                      <span class="list-result-sup">書籍の更新情報</span>
                    </div>
                    <div class="list-result-note mb0" v-else-if="list.type == 'knowledge'">
                      <span class="list-result-sup"><span class="category-item">最新ナレッジ</span><span class="category-item">{{list.knowledge_type_name}}</span></span>
                    </div>
                    <div class="list-result-note mb0" v-if="list.type == 'pj'">
                      <span class="list-result-sup">資料</span>
                    </div>
                  </div>

                  <div class="list-result-item-sub">
                    <button class="btn delete" type="button"
                      @click="action.deleteItem(list.alert_id)"
                    >
                      <FontawesomeIcon :icon="['far', 'times']" class="icn" />
                    </button>
                  </div>
                </li>
              </ul>
            </template>
          </SPScrollList>
        </div>
      </div>
    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'

import { AlertList } from '@/logic/alert/AlertList'
import * as logicProfile from '@/logic/profile/Profile'

import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPProfileAlertSetting from '@/components/sp/popup/SPProfileAlertSetting.vue'
import SPProfileContractedBookSetting from '@/components/sp/popup/SPProfileContractedBookSetting.vue'
import SPAlertListDeleteConfirm from '@/components/sp/popup/SPAlertListDeleteConfirm.vue'
import SPAlertListDeleteInBulkConfirm from '@/components/sp/popup/SPAlertListDeleteInBulkConfirm.vue'
import SPScrollList from '@/components/sp/partial/SPScrollList.vue'

export default defineComponent({
  components: {
    SPMenu,
    SPProfileAlertSetting,
    SPProfileContractedBookSetting,
    SPAlertListDeleteConfirm,
    SPAlertListDeleteInBulkConfirm,
    SPScrollList
  },
  setup (props, context) {
    onMounted(() => {
      group1.init()
    })
    const group1 = logicProfile.getGroup(props, context)

    const _state = reactive({
      visibleMenu: false,
      visibleProfileAlertSetting: false,
      visibleProfileContractedBookSetting: false
    })

    return {
      group1,
      _state,
      ...AlertList(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-heading-row {
    height: $sp-main-heading-height;
  }
  &-container {
    @include changeHeightOnScroll($sp-header-height + $sp-main-heading-height);
    .notification {
      padding: 20px;
      border-bottom: 1px solid $color-line;
      &-text {
        font-size: 1.6rem;
        color: $color-content;
      }
      &-link {
        margin-top: 16px;
        font-size: 1.4rem;
        color: $color-link;
      }
    }
    .date {
      font-size: 1.4rem;
      color: $color-content;
      padding: 32px 20px;
      background-color: $color-bg-paper;
    }
  }
}
.menu-btn {
  &-2 {
    border-top-left-radius: 8px;
    .icn {
      transition: all .2s ease;
    }
    .icn-opened {
      opacity: 0;
    }
    .icn-closed {
      opacity: 1;
    }
  }
}
.list-result-note {
  .category-item:not(:last-child) {
    margin-right: 1em;
  }
}
// .main-heading-delete{
//   text-align: right;
// }
// .main-heading-delete button{
//   color: #005BAC;
// }
// .list-result-02 .list-result-item-menu .fa-times{
//   font-size: 12px;
//   color: #3E3E3E;
// }
// .list-result-state{
//   font-size: 14px;
//   font-weight: normal;
//   color: #999;
// }
// .list-result-title{
//   color: #ccc;
// }
// .list-result-state + .list-result-title{
//   margin-top: 13px;
// }
// .list-result-text,
// .list-result-category,
// .list-result-author,
// .list-result-date{
//   ul{
//     li{
//       list-style: none;
//       font-size: 14px;
//       color: #999999;
//     }
//   }
// }
// .list-result-text,
// .list-result-category,
// .list-result-date{
//   margin-top: 15px;
//   ul{
//     letter-spacing: -0.4em;
//     li{
//       display: inline-block;
//       letter-spacing: normal;
//       margin-right: 15px;
//     }
//   }
// }
// .list-result-author{
//   margin-top: 1px;
//   min-height: 40px;
//   line-height: 40px;
//   ul{
//     li{
//       img{
//         vertical-align: middle;
//         margin-left: 10px;
//       }
//     }
//   }
// }
// .list-result-author + .list-result-text,
// .list-result-author + .list-result-category{
//   margin-top: 0;
// }
</style>
